import { useCallback } from 'react';

import { config } from '@/config/config';
import { openAuthorizeUrl } from '@/modules/integrations/openAuthorizeUrl';
import type { components } from '@/types/apiSchema';

type ConnectSource = NonNullable<components['schemas']['SlackConnectSource']>;

interface ConnectSlackOptions {
  /**
   * Opens Slack in a new tab so the current page stays put. Entry points pass
   * it; "Try again" on a result page omits it, since it already runs in the
   * Slack tab.
   */
  newTab?: boolean;
}

/**
 * Returns a stable handler that starts the Slack OAuth flow at the backend
 * authorize endpoint.
 */
export const useConnectSlack = () => {
  return useCallback(
    (connectSource: ConnectSource, options: ConnectSlackOptions = {}) => {
      const authorizeEndpoint = new URL(
        '/slack/oauth/authorize',
        config.app.apiBaseUrl,
      );

      authorizeEndpoint.searchParams.set('connectSource', connectSource);

      openAuthorizeUrl(authorizeEndpoint.toString(), options);
    },
    [],
  );
};
